var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters } from "vuex";
import BillHeader from "./BillHeader.vue";
import BillTable from "./BillTable.vue";
import UpperSupCheckService from '../../../api/UpperSupCheckService';
import { handle, EHanleType } from '../../../biz/upperSupCheckBiz';
import { UrlHelper } from "../../../helper/UrlWrapper";
import { numAdd } from '../../../helper/calucate';
import _ from 'lodash';
import GLOBAL_VUE from '../../../globalVue';
import { Loading } from 'element-ui';
import { UpperSupCheckRefresh } from "../../../constant/eventKey";
import { toDetail } from '../../../helper/util';
import { EBillType } from '../../../enum/EBillType';
import AddDialog from '../../upperPayment/AddDialog';
import ArtMsglist from "../../../components/alert/ArtMsglist.vue";
import CommonService from "../../../api/CommonService";
var Bill = (function (_super) {
    __extends(Bill, _super);
    function Bill() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tempSelectRows = [];
        _this.data = [];
        _this.total = 0;
        _this.handleType = EHanleType;
        _this.dialogVisible = false;
        _this.exportType = "1";
        _this.order_money = '';
        _this.eventGetList = function () { return _this.getList(); };
        return _this;
    }
    Bill.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        this.filter = filter;
        this.getList();
    };
    Bill.prototype.getList = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = Object.assign(this.filter, this.$refs.pagination.pager);
        this.service.getOrderList(params)
            .then(function (res) {
            var data = res.data.data || [];
            _this.data = data.map(function (item) {
                var depot_names = Array.isArray(item.depot_names) ? item.depot_names : [];
                item.depot_names = depot_names.join('、');
                return item;
            });
            _this.total = res.data.total;
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    Bill.prototype.pageChange = function () {
        this.getList();
    };
    Bill.prototype.selectionChange = function (rows) {
        this.tempSelectRows = rows;
    };
    Bill.prototype.checkResult = function () {
        if (!this.tempSelectRows || !this.tempSelectRows.length) {
            this.$message.error("请选择单据");
            return false;
        }
        return true;
    };
    Bill.prototype.handle = function (type) {
        if (!this.checkResult()) {
            return;
        }
        handle(type, this, this.tempSelectRows.map(function (item) { return item.order_id; }).join(","));
        if (type == EHanleType.Audit) {
            window._czc.push(["_trackEvent", '供应商对账单列表', '供应商对账单审核']);
        }
        else if (type == EHanleType.Delete) {
            window._czc.push(["_trackEvent", '供应商对账单列表', '供应商对账单废弃']);
        }
    };
    Bill.prototype.addPay = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isSameUpperSup, sumRow, instance;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.order_money = '';
                        if (!this.checkResult()) {
                            return [2];
                        }
                        if (this.tempSelectRows.some(function (item) { return item.order_status != 2 && item.order_status != 6; })) {
                            this.$message.error("只能选择已审核或待付款的单据");
                            return [2];
                        }
                        isSameUpperSup = true;
                        sumRow = {
                            supplier_upper_name: this.tempSelectRows[0].supplier_upper_name,
                            payment_money: 0,
                            statement_order_ids: []
                        };
                        this.tempSelectRows.forEach(function (item) {
                            if (item.supplier_upper_name != sumRow.supplier_upper_name) {
                                isSameUpperSup = false;
                            }
                            sumRow.payment_money = numAdd(sumRow.payment_money, item.order_remain_payment_money || 0);
                            sumRow.statement_order_ids.push(item.order_id);
                        });
                        if (!isSameUpperSup) {
                            this.$message.error("请选择同一个供应商的对账单生成付款单据！");
                            return [2];
                        }
                        return [4, this.service.realisticMoney({ order_ids: sumRow.statement_order_ids.join(',') }).then(function (res) {
                                if (res.data.code == 0) {
                                    _this.order_money = res.data.data.payment_money;
                                }
                                else {
                                    _this.$dialog(ArtMsglist, {
                                        data: {
                                            msgData: res.data.data
                                        }
                                    }, {
                                        title: "提示",
                                        width: 450,
                                        height: 350
                                    });
                                    return;
                                }
                            })];
                    case 1:
                        _a.sent();
                        if (this.order_money == '') {
                            return [2];
                        }
                        instance = this.$dialog(AddDialog, {
                            data: {
                                supplier_upper_name: sumRow.supplier_upper_name,
                                payment_money: this.order_money,
                                formData: {
                                    statement_order_ids: sumRow.statement_order_ids.join(','),
                                }
                            }
                        }, {
                            title: "新增付款单",
                            width: 600,
                            height: 520
                        }).instance;
                        instance.$on('ok', function () {
                            _this.getList();
                            window._czc.push(["_trackEvent", '供应商对账单列表', '供应商对账单付款']);
                        });
                        return [2];
                }
            });
        });
    };
    Bill.prototype.addTab = function (options) {
        options.opener = this;
        GLOBAL_VUE.$emit('addTab', options);
    };
    Bill.prototype.toDetail = function (row) {
        toDetail(EBillType.UpperSupCheck, row.order_id, this);
    };
    Bill.prototype.operateCommand = function (command) {
        switch (command) {
            case 1:
                this.handle(this.handleType.Delete);
                break;
            case 2:
                this.mulPrint();
                break;
            case 3:
                this.export();
                break;
        }
    };
    Bill.prototype.getSelectIds = function () {
        var orderIds = this.tempSelectRows.map(function (item) { return item.order_id; });
        return orderIds;
    };
    Bill.prototype.mulPrint = function () {
        var orderIds = this.getSelectIds();
        if (!orderIds.length) {
            this.$message.error("请选择订单");
            return;
        }
        var url = "./static/js/print/print2.html";
        url = UrlHelper.addParam(url, 'type', "UpperSupCheck");
        url = UrlHelper.addParam(url, 'order_id', orderIds.join(","));
        url = UrlHelper.addParam(url, 'token', this.user.token);
        UrlHelper.windowOpenIntercept(url);
        window._czc.push(["_trackEvent", '供应商对账单列表', '供应商对账单打印']);
    };
    Bill.prototype.export = function () {
        this.dialogVisible = true;
    };
    Bill.prototype.confirmExport = function () {
        var _this = this;
        var orderIds = this.getSelectIds();
        var url = "supplierclientapi/upperstatementorder/export" + (this.exportType == '1' ? '' : '_detail') + "?order_id=" + orderIds.join(",");
        url = UrlHelper.addParam(url, 'token', this.user.token);
        var filter = _.cloneDeep(this.$refs.billHeader.formData);
        if (_.isDate(filter.s_time)) {
            filter.s_time = filter.s_time.format('yyyy-MM-dd');
            filter.e_time = filter.e_time.format('yyyy-MM-dd');
        }
        this.filter = filter;
        for (var key in this.filter) {
            this.filter[key] = (this.filter[key] === undefined || this.filter[key] === null) ? '' : this.filter[key];
            url = UrlHelper.addParam(url, key, this.filter[key]);
        }
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        if (this.exportType == '1') {
            window._czc.push(["_trackEvent", '供应商对账单列表', '导出对账单', '导出单据']);
        }
        if (this.exportType == '2') {
            window._czc.push(["_trackEvent", '供应商对账单列表', '导出对账单', '导出对账明细']);
        }
    };
    Bill.prototype.created = function () {
        this.service = UpperSupCheckService.getInstance();
        this.commonService = CommonService.getInstance();
        GLOBAL_VUE.$on(UpperSupCheckRefresh, this.eventGetList);
    };
    Bill.prototype.beforeDestroy = function () {
        GLOBAL_VUE.$off(UpperSupCheckRefresh);
    };
    Bill.prototype.mounted = function () {
        this.$refs.billHeader.search();
    };
    Bill = __decorate([
        Component({
            components: {
                BillHeader: BillHeader,
                BillTable: BillTable
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], Bill);
    return Bill;
}(Vue));
export default Bill;
